var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EmptyValidation } from "@domains/utils/commonText";
var LeadPresenter = /** @class */ (function () {
    function LeadPresenter(leadUseCase, leadActions) {
        this.leadUseCase = leadUseCase;
        this.leadActions = leadActions;
        this.isClearPan = false;
        this.paginationReset = false;
    }
    LeadPresenter.prototype.getCountryList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.countryList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getRemappingClientTaskCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.remappingClientTaskCount.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    LeadPresenter.prototype.verificationLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.verificationUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getCategorySubCategoryByIssuerName = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.getCategorySubCategoryByIssureNameUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getPartnerCodes = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.partnerCodeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getPipelineAgingLeadCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.pipelineAgingLeadCount.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    LeadPresenter.prototype.getPANVerificationStatusNew = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.panVerificationNew.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getDIYSearchAOPLeadDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.DIYSearchAOPLeadDetailsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getCriticalfollowUpCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.criticalFollowUP.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    LeadPresenter.prototype.getFollowUpAgingRMs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.followUpAgingRMs.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.searchProductByIssureName = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.searchProductByIssureName.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.checkPanDedupe = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.checkPanDedupe.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.updateIsClearPan = function (clearPan) {
        this.isClearPan = clearPan;
    };
    LeadPresenter.prototype.getClearPan = function () {
        return this.isClearPan;
    };
    LeadPresenter.prototype.getPanMandatoryStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.panMandatory.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getSbCodes = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.sbCodeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getChildLeadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.childLeadData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getCategoryMasterData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.categoryMasterUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.getProductNames = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.productNamesUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getLeadPriority = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.leadPriority.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getSelfAssignDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.selfAssignUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.updateInternalComments = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.updateInternalCommentsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getSendVerificationLinkDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.sendVerificationLink.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getProductFeedbacks = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.productFeedbacks.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getViewEditLeadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.editLeadViewUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getViewEditMultipleLeadsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.viewEditMultipleLeadsUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.checkMomStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.checkMomStatus.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.sendViewMomTemplate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.sendViewMomTemplate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.sendProductPitchEmail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.sendProductPitchEmail.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.clickToCall = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.clickToCall.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getClientProfilePicture = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.clientProfilePicture.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.downloadLeadDashboardData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.leadDashboard.execute({
                onSuccess: function (data) {
                    resolve(data.leadDashboardBase64String);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getLeadLogsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.leadLogs.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getLeadRedirection = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.leadRedirection.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.updateLead = function (leadObj) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.updateLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, leadObj);
        });
    };
    LeadPresenter.prototype.saveLead = function (leadObj) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.saveLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, leadObj);
        });
    };
    LeadPresenter.prototype.getPurchaseHistoryActions = function (req) {
        var _this = this;
        this.leadActions.purchaseHistory.clear("PurchaseHistory");
        this.leadActions.purchaseHistory.hideError("PurchaseHistory");
        this.leadActions.purchaseHistory.loader("PurchaseHistory");
        this.leadUseCase.leadPurchaseHistory.execute({
            onSuccess: function (data) {
                if (data.data.length === 0) {
                    _this.leadActions.purchaseHistory.addMsg(EmptyValidation.default, true, "", "PurchaseHistory");
                }
                _this.leadActions.purchaseHistory.updatePurchaseHistory(data, "PurchaseHistory");
                _this.leadActions.purchaseHistory.stopLoader("PurchaseHistory");
            },
            onError: function (error) {
                _this.leadActions.clientProfileDetails.setError({ isOpen: true, error: error }, "PurchaseHistory");
                _this.leadActions.purchaseHistory.stopLoader("PurchaseHistory");
            },
        }, req);
    };
    LeadPresenter.prototype.getSearchLeadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.searchLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.isAuthorizedToAssignLead = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.isAuthorizedToAssignLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.reassignLead = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.reassignLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.editAccessLead = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.editLeadAccess.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.updateClientProfileDetails = function (req) {
        var _this = this;
        this.leadActions.clientProfileDetails.hideError("ClientProfileDetails");
        this.leadActions.clientProfileDetails.loader("ClientProfileDetails");
        this.leadUseCase.clientProfileDetails.execute({
            onSuccess: function (data) {
                _this.leadActions.clientProfileDetails.updateClientProfileDetails(data, "ClientProfileDetails");
                _this.leadActions.clientProfileDetails.stopLoader("ClientProfileDetails");
            },
            onError: function (error) {
                _this.leadActions.clientProfileDetails.setError({ isOpen: true, error: error }, "ClientProfileDetails");
                _this.leadActions.clientProfileDetails.stopLoader("ClientProfileDetails");
            },
        }, req);
    };
    LeadPresenter.prototype.clearClientProfileData = function () {
        this.leadActions.clientProfileDetails.updateClientProfileDetails({}, "ClientProfileDetails");
    };
    LeadPresenter.prototype.getEmployeeList = function (req) {
        var _this = this;
        this.leadUseCase.employeeList.execute({
            onSuccess: function (data) {
                _this.leadActions.employeeList.employeeList(data, "EMPLOYEELIST");
            },
            onError: function (error) { },
        }, req);
    };
    LeadPresenter.prototype.paginationResetOnFilterApply = function (val) {
        this.paginationReset = val;
    };
    LeadPresenter.prototype.getLeadDashboarData = function (req, isDateSkip, leadDashboardListData) {
        var _this = this;
        if (isDateSkip === void 0) { isDateSkip = false; }
        req.isDateSkip = isDateSkip;
        this.leadActions.leadDashboard.hideError("LeadDashboard");
        this.leadActions.leadDashboard.loader("LeadDashboard");
        this.leadUseCase.leadDashboard.execute({
            onSuccess: function (data) {
                // if (
                //   !this.paginationReset &&
                //   leadDashboardListData &&
                //   leadDashboardListData.length > 0
                // ) {
                //   data = {
                //     ...data,
                //     leadDashboardList: [
                //       ...leadDashboardListData,
                //       ...data.leadDashboardList,
                //     ],
                //   };
                // }
                _this.leadActions.leadDashboard.updateDashboardData(data, "LeadDashboard");
                _this.leadActions.leadDashboard.stopLoader("LeadDashboard");
            },
            onError: function (error) {
                _this.leadActions.leadDashboard.setError({ isOpen: true, error: error }, "LeadDashboard");
                _this.leadActions.leadDashboard.stopLoader("LeadDashboard");
            },
        }, req);
    };
    LeadPresenter.prototype.getLeadDBSummaryActions = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.leadDBSummary.execute({
                            onSuccess: function (data) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, resolve(data)];
                            }); }); },
                            onError: function (error) { return reject(error); },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.updateViewLeadActions = function (req) {
        var _this = this;
        this.leadUseCase.leadView.execute({
            onSuccess: function (data) {
                _this.leadActions.leadDBSummaryAction.updateLeadDBSummary(data, "LeadDBSummaryDetails");
            },
            onError: function (error) {
                console.log("error", error);
            },
        }, req);
    };
    LeadPresenter.prototype.checkDedupe = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.checkDedupe.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.addEditLeadPastIntraction = function (req) {
        var _this = this;
        this.leadActions.addEditLeadPastIntraction.hideError("PastIntraction");
        this.leadActions.addEditLeadPastIntraction.loader("PastIntraction");
        this.leadUseCase.addEditLeadPastIntractions.execute({
            onSuccess: function (data) {
                _this.leadActions.addEditLeadPastIntraction.addEditLeadPastIntraction(data, "PastIntraction");
                _this.leadActions.addEditLeadPastIntraction.stopLoader("PastIntraction");
            },
            onError: function (error) {
                _this.leadActions.addEditLeadPastIntraction.setError({ isOpen: true, error: error }, "PastIntraction");
                _this.leadActions.addEditLeadPastIntraction.stopLoader("PastIntraction");
            },
        }, req);
    };
    LeadPresenter.prototype.getViewLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // this.leadActions.getViewLeadData.hideError("ViewLead");
                // this.leadActions.getViewLeadData.loader("ViewLead");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.viewLeadData.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.getValidateOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.validateOtp.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.getLeadOtp = function (req) {
        var _this = this;
        return new Promise(function (Resolve, Reject) {
            _this.leadUseCase.leadOtp.execute({
                onSuccess: function (data) {
                    Resolve(data);
                },
                onError: function (error) {
                    Reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.updateClientRegistration = function (req) {
        var _this = this;
        return new Promise(function (Resolve, Reject) {
            _this.leadUseCase.updateClientRegistration.execute({
                onSuccess: function (data) {
                    Resolve(data);
                },
                onError: function (error) {
                    Reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.saveLeadUCC = function (req) {
        var _this = this;
        return new Promise(function (Resolve, Reject) {
            _this.leadUseCase.savePartnerUPC.execute({
                onSuccess: function (data) {
                    Resolve(data);
                },
                onError: function (error) {
                    Reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.leadsPitchProd = function (req) {
        var _this = this;
        return new Promise(function (Resolve, Reject) {
            _this.leadUseCase.leadPitchProduct.execute({
                onSuccess: function (data) {
                    Resolve(data);
                },
                onError: function (error) {
                    Reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getInternalComments = function (req) {
        var _this = this;
        return new Promise(function (Resolve, Reject) {
            _this.leadUseCase.internalComments.execute({
                onSuccess: function (data) {
                    Resolve(data);
                },
                onError: function (error) {
                    Reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getPANVerificationStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.panVerificationUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.checkPartnerDedupe = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.checkPartnerDedupe.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.getValidationPipelineAmount = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.leadUseCase.validationPipelineAmount.execute({
                            onSuccess: function (data) { return resolve(data); },
                            onError: function (error) { return reject(error); },
                        }, req);
                    })];
            });
        });
    };
    LeadPresenter.prototype.clientProfileUpdate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.clientProfileUpdate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getCriticalPriorityAging = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.criticalPriorityAging.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    LeadPresenter.prototype.checkUccStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.checkUccStatus.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.checkUccDedup = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.checkUccDedup.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.clientEmailUpdate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.clientEmailUpdate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.clientPanUpdate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.clientPanUpdate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.editMomTemplate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.editMomTemplate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getMomAttachFiles = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.getMomAttachFiles.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getViewMomDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.getViewMomDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getMomDownloadAttachFile = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.getMomDownloadAttachFile.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LeadPresenter.prototype.getViewMomAttachmentDownload = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.leadUseCase.getViewMomAttachmentDownload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return LeadPresenter;
}());
export default LeadPresenter;
